<template>
  <div style="overflow:auto;height:100%;backgroundColor:#fff">
    <div style="position: fixed;padding: 1vh;">
      <!-- <img style="text-align:left" src="../../../assets/image/back.png" alt /> -->
      <el-page-header @back="goBack" content="规范说明"></el-page-header>
    </div>
    <div
      style="fontSize:24px;font-weight:blod;margin-bottom:100px;margin-top:50px;font-weight:bold;"
    >人脸采集照片规范说明：</div>
    <div
      style="fontSize:24px;color:red;text-align:left;margin-left: 332px;"
    >采集以下照片会导致识别体验下降，误识别或无法识别</div>
    <div>
      <img src="../../../assets/image/guifan_files/img_01.png" alt />
    </div>
    <div>
      <img src="../../../assets/image/guifan_files/img_02.png" alt />
    </div>
    <div
      style="fontSize:24px;color:red;text-align:left;margin-left: 332px;"
    >采集以下照片会导致识别体验下降，误识别或无法识别：</div>
    <div>
      <img src="../../../assets/image/guifan_files/img_04.png" alt />
    </div>

    <div>
      <img src="../../../assets/image/guifan_files/img_05.png" alt />
    </div>
  </div>
</template>
	<script>
export default {
  data() {
    return {}
  },
  methods: {
    goBack() {
      this.$router.go(-1) //返回上一层
    }
  }
}
</script>
	<style  scoped>
	
				
</style>